import { Component, OnInit } from '@angular/core';
import { VillageVideoItems, VillageVideoItemsService } from 'src/app/core/services/village-video-items.service';
import { Lightbox } from 'ngx-lightbox';
import { FormBuilder, FormControl } from '@angular/forms';
@Component({
  selector: 'app-village-video-items',
  templateUrl: './village-video-items.component.html',
  styleUrls: ['./village-video-items.component.scss']
})
export class VillageVideoItemsComponent implements OnInit {
/* --------------------------------- Fields --------------------------------- */
  villageVideoItems!: VillageVideoItems[];
  albums: any;
  mediaType = new FormControl('IMAGE');

/* ------------------------------- Constructor ------------------------------ */

  constructor(private fb: FormBuilder,private villageVideoItemsService: VillageVideoItemsService,private _lightbox: Lightbox) { }

/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {
    this.villageVideoItemsService.getMediaByType('IMAGE').subscribe(data=>{
      this.albums = data.map(single=><any>{
        src: single.image.url,
        caption: single.en_caption,
        thumb: single.image.url
     });
    });
    this.villageVideoItemsService.getMediaByType('VIDEO').subscribe(data=>{
      console.log(data);
      this.villageVideoItems = data;
    });
  }

  open(index: number): void {
    this._lightbox.open(this.albums, index);
  }

  close(): void {
    // close lightbox programmatically
    this._lightbox.close();
  }

}
